<template>
  <div class="power-list-tree">
    <el-input class="power-list-search-input" placeholder="请输入权限名称" v-model="filterText" clearable>
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <div class="power-list-tree-content">
      <div :class="['power-list-type', disabled && 'power-list-type-disabled']" v-for="item in powerTypeList" :key="item.type">
          <span class="type-name" @click="showTree(item.type)">
            <i :class="[currentShowTree.includes(item.type) ? 'el-icon-caret-bottom': 'el-icon-caret-right']"></i>{{item.name}}
          </span>
        <slot name="homePage" v-if="currentShowTree.includes(item.type) && item.type ==='other' && !noGroup"></slot>
        <div class="home-page-empty" v-else-if="currentShowTree.includes(item.type) && item.type ==='other' && noGroup">
          <span>请先添加群组</span>
        </div>
        <el-tree
          v-if="item.type !=='other'"
          :key="item.type"
          v-loading="loadingPowerLists"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          v-show="currentShowTree.includes(item.type)"
          :empty-text="noGroup ? '请先添加群组' : '暂无数据'"
          :ref="item.type"
          :data="powersListObj[item.type]"
          :props="defaultProps"
          node-key="id"
          :check-strictly="loadingPowerLists || isSelectingParent"
          :default-checked-keys="checkedList[item.type]"
          show-checkbox
          :filter-node-method="filterNode"
          @check="(data, checked) => handleChecked(data, checked, item.type)">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <transition name="checkbox-fade">
              <span class="custom-checkbox" v-show="data.halfCheckedStatus" :key="data.id"></span>
            </transition>
            <span v-html="node.label"></span>
            <span v-if="data.totalMenus && !data.link">
              ({{data.checkedMenus + '/' + data.totalMenus}})
            </span>
            <span class="role-power-tree-icon" v-if="node.level > 1">
              <img @mouseover="showToolTip" @mouseleave="hideToolTip" @click="showPowerDialog(node, data)" src="./assets/role-power-tree-icon.png">
            </span>
          </span>
        </el-tree>
      </div>
      <span v-show="tipShow" ref="toolTip" class="power-list-tree-tooltip"><i class="triangle"></i>查看谁有该权限</span>
      <el-dialog class="power-list-tree-dialog" width="40%" :title="dialog.title" :visible.sync="dialog.visible" :close-on-click-modal="false" center @close="clearDialogData">
        <div class="power-list-tree-dialog-content">
          <div class="group" v-loading="dialog.loadGroupData">
            <h5>群组名称</h5>
            <p v-for="group in dialog.groupData" :key="group.id">{{group.name}}</p>
          </div>
          <div class="member">
            <el-input placeholder="请输入成员名称" prefix-icon="el-icon-search" v-model="dialog.searchMemberKey" @input="getMemberData(dialog.menuId)" clearable></el-input>
            <el-table class="power-list-tree-dialog-content-table" :data="dialog.memberData" height="calc(100% - 65px)" v-loading="dialog.loadMemberData">
              <el-table-column label="群组成员" prop="name" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="类型" prop="groupType" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="所属部门" prop="belongDeptName" align="center" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <el-pagination :current-page="dialog.member.index"
                           :page-size="dialog.member.pageSize"
                           :total="dialog.member.total"
                           layout="slot">
              <span @click="prevMemberData" :class="[disablePrev && 'disable-prev']"><i class="fa fa-step-backward"></i>上页</span>
              <span @click="nextMemberData" :class="[disableNext && 'disable-next']">下页<i class="fa fa-step-forward"></i></span>
            </el-pagination>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="dialog.visible = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'power-list-tree',
  props: {
    powersListObj: Object,
    checkedList: Object,
    loadingPowerLists: Boolean,
    isAdmin: Boolean,
    disabled: Boolean,
    noGroup: Boolean
  },
  data () {
    return {
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentShowTree: ['menu'],
      isSelectingParent: false,
      needExpandFlag: false,
      tipShow: false,
      dialog: {
        title: '',
        visible: false,
        groupData: [],
        loadGroupData: false,
        memberData: [],
        loadMemberData: false,
        searchMemberKey: '',
        menuId: '',
        member: {
          total: 0,
          index: 1,
          size: 10
        }
      }
    }
  },
  computed: {
    powerTypeList () {
      let powerTypeList = [
        {name: '菜单权限', type: 'menu'},
        {name: '流程权限', type: 'process'},
        {name: 'APP权限', type: 'APP_Other'},
        {name: '企业微信权限', type: 'qywx'},
        {name: '其他权限', type: 'other'}
      ]
      if (this.isAdmin) {
        powerTypeList.push({name: '系统权限', type: 'system'})
      }
      return powerTypeList
    },
    disablePrev () {
      return this.dialog.member.index === 1
    },
    disableNext () {
      return this.dialog.member.total < (this.dialog.member.size * this.dialog.member.index)
    }
  },
  watch: {
    filterText (val) {
      let currentId = null
      // 展开数据存在的节点
      if (val || val === 0) {
        Object.keys(this.powersListObj).forEach(key => {
          let type = key
          if (key === 'app') {
            type = 'APP_Other'
          }
          for (let i = 0; i < this.powersListObj[key].length; i++) {
            if (this.powersListObj[key][i].name && this.powersListObj[key][i].name.includes(val)) {
              currentId = this.powersListObj[key][i].id
            } else {
              currentId = this.findName(this.powersListObj[key][i], val)
            }
            if (currentId) {
              if (!this.currentShowTree.includes(type)) {
                this.currentShowTree.push(type)
              }
            }
          }
        })
      }
      // 搜索
      this.powerTypeList.forEach(tree => {
        if (tree.type !== 'other') {
          this.$refs[tree.type] && this.$refs[tree.type][0].filter(val)
        }
      })
    }
  },
  methods: {
    findName (parent, val) {
      if (parent.name && parent.name.includes(val)) {
        return parent
      }
      for (const item of parent.children) {
        let result = this.findName(item, val)
        if (result) {
          return result
        }
      }
    },
    // 点击展示
    async showTree (type) {
      if (this.loadingPowerLists) {
        return this.$message.warning('数据加载中，请稍候')
      }
      if (this.currentShowTree.includes(type)) {
        let index = this.currentShowTree.findIndex(e => e === type)
        this.currentShowTree.splice(index, 1)
      } else {
        // await this.$emit('getPowersList', type)
        this.currentShowTree.push(type)
      }
    },
    // 处理子选父, 父选子问题
    handleChecked (data, checked, type) {
      let checkedKeys = this.$refs[type][0].getCheckedKeys()
      let halfCheckedKeys = this.$refs[type][0].getHalfCheckedKeys()
      // 手动点击时暂时开启严格不相关模式
      this.isSelectingParent = true
      this.$nextTick(() => {
        // 如果点的是按钮且是取消的时候, 则只处理按钮, 其他节点则手动再次选中
        // todo: 这里使用的是 不含 链接 和 children 来判断是否按钮, 不够严谨, 56期新增了 functionType: '5' 来判断, 还未上线, 上线后可更改
        if (!data.link && data.children && data.children.length === 0 && !checked.checkedKeys.includes(data.id)) {
          data.parentId && this.$refs[type][0].setCheckedKeys(this.$_.difference(this.checkedList[type], [data.id]))
          checkedKeys = this.$_.difference(this.checkedList[type], [data.id])
        }
        this.checked(checkedKeys, halfCheckedKeys, type)
      })
    },
    checked (checkedKeys, halfCheckedKeys, type) {
      // 每次点击暂存当前选中的节点数据
      this.$nextTick(() => {
        // 选中子节点时默认选中父节点
        let needCheckedKeys = this.$_.concat(this.$_.difference(halfCheckedKeys, checkedKeys), checkedKeys)
        this.$refs[type][0].setCheckedKeys(needCheckedKeys)
        this.$emit('setCurrentSelect', {type: type, checked: needCheckedKeys})
        this.isSelectingParent = false
      })
    },
    filterNode (value, data, node) {
      if (!value) return true
      return data.name.indexOf(value) !== -1 || (node.parent && node.parent.data.name && node.parent.data.name.indexOf(value) !== -1 && node.isLeaf)
    },
    // 获取有该权限的群组
    getGroupData (id) {
      this.dialog.loadGroupData = true
      this.$axios.get(`/auth-api/roles/getRolesByMenuId`, {params: { menuId: id }}).then(res => {
        this.dialog.groupData = res.data
        this.dialog.loadGroupData = false
      })
    },
    // 获取有该权限的成员
    getMemberData (id) {
      this.dialog.loadMemberData = true
      this.$axios.get(`/auth-api/roles/getRoleMemberByMenuId`, {params: {index: this.dialog.member.index, size: this.dialog.member.size, filters: { menuId: id, name: this.dialog.searchMemberKey }}}).then(res => {
        this.dialog.memberData = res.data.items
        this.dialog.member.total = res.data.total
        this.dialog.loadMemberData = false
      })
    },
    prevMemberData () {
      if (this.dialog.member.index === 1) {
        return null
      }
      this.dialog.member.index -= 1
      this.getMemberData(this.dialog.menuId)
    },
    nextMemberData () {
      if (this.dialog.member.total < (this.dialog.member.size * this.dialog.member.index)) {
        return null
      }
      this.dialog.member.index += 1
      this.getMemberData(this.dialog.menuId)
    },
    showPowerDialog (node, data) {
      let name = data.name
      // 按钮的弹窗名改一下
      if (data.type === '5') {
        name = node.parent.data.name + '-' + name
      }
      this.dialog.title = `有${name}权限的群组和成员`
      this.dialog.menuId = data.id
      this.dialog.visible = true
      this.getGroupData(data.id)
      this.getMemberData(data.id)
    },
    clearDialogData () {
      this.dialog.menuId = ''
      this.dialog.groupData = []
      this.dialog.memberData = []
      this.dialog.searchMemberKey = ''
      this.dialog.member.index = 1
    },
    showToolTip (e) {
      this.tipShow = true
      this.$refs.toolTip.style.left = e.target.x - 42 + 'px'
      this.$refs.toolTip.style.top = e.target.y + 20 + 'px'
    },
    hideToolTip (e) {
      this.tipShow = false
    }
  }
}
</script>

<style lang="scss">
  .power-list-tree{
    height: calc(100% - 40px);
    box-sizing: border-box;
    margin-bottom: 5px;
    .power-list-search-input{
      margin-bottom: 14px;
    }
    .power-list-tree-content{
      height: calc(100% - 48px);
      overflow: scroll;
      .power-list-type{
        .type-name{
          display: inline-block;
          width: 100%;
          height: 39px;
          line-height: 39px;
          font-size: 12px;
          color: #232323;
          cursor: pointer;
          border-bottom: 1px solid #EDF2F5;
          margin-bottom: 10px;
          .el-icon-caret-right,.el-icon-caret-bottom{
            color: #C2C3C4;
            margin-right: 5px;
            font-size: 16px;
            &:hover{
              color: var(--primary, #409EFF);
            }
          }
          .el-icon-caret-bottom{
            color: var(--primary, #409EFF);
          }
        }
        .home-page-empty{
          height: 60px;
          line-height: 60px;
          text-align: center;
          color: #909399;
        }
        .el-tree{
          width: 100%;
          &>.el-tree-node{
            min-width: 100%;
            display: inline-block;
          }
        }
        .el-tree-node{
          .el-tree-node__content{
            .el-tree-node__expand-icon{
              &::before{
                font-size: 16px;
              }
              &.expanded{
                color: var(--primary, #409EFF);
              }
              &:hover:not(.is-leaf){
                color: var(--primary, #409EFF);
              }
            }
            .el-checkbox .el-checkbox__inner{
              background-color: #ffffff;
              &::after{
                border: 1px solid var(--primary, #409EFF);
                border-left: 0;
                border-top: 0;
              }
            }
            .custom-tree-node{
              position: relative;
              line-height: 16px;
              width: 100%;
              padding-right: 30px;
              .custom-checkbox{
                display: inline-block;
                width: 14px;
                height: 14px;
                pointer-events: none;
                position: absolute;
                left: -22px;
                top: 1px;
                border: 1px solid var(--primary, #409EFF);
                border-radius: 2px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                background-color: #FFF;
                z-index: 1;
                &:before{
                  content: "";
                  position: absolute;
                  display: block;
                  background-color: var(--primary, #409EFF);
                  height: 2px;
                  transform: scale(0.5);
                  left: 0;
                  right: 0;
                  top: 5px;
                }
              }
              &:hover{
                .role-power-tree-icon{
                  display: inline-block;
                }
              }
              .role-power-tree-icon{
                display: none;
                width: 12px;
                height: 12px;
                position: absolute;
                right: 15px;
                top: 2px;
                z-index: 1;
                &:hover{
                  img{
                    border-left: 100px solid transparent;
                    filter: drop-shadow(-100px 0 0 var(--primary, #4592E4));
                  }
                }
              }
              .checkbox-fade-enter-active, .checkbox-fade-leave-active {
                transition: opacity .5s;
              }
              .checkbox-fade-leave-to {
                opacity: 0;
              }
            }
          }
        }
        &.power-list-type-disabled{
          .type-name{
            .el-icon-caret-right,.el-icon-caret-bottom{
              color: #C2C3C4;
              margin-right: 5px;
              font-size: 16px;
              &:hover{
                color: #C2C3C4;
              }
            }
          }
          .el-tree-node{
            .el-tree-node__content{
              .el-tree-node__expand-icon{
                &.expanded{
                  color: #C0C4CC;
                }
                &:hover:not(.is-leaf){
                  color: #C0C4CC;
                }
              }
              .el-checkbox .el-checkbox__inner{
                border-color: #ABABAB;
                &::after{
                  border: 1px solid #ABABAB;
                  border-left: 0;
                  border-top: 0;
                }
              }
              .custom-tree-node{
                .custom-checkbox{
                  border-color: #ABABAB;
                  &:before{
                    background-color: #ABABAB;
                  }
                }
              }
            }
          }
        }
        .el-select{
          margin-left: 10px;
        }
      }
      .power-list-tree-tooltip{
        position: fixed;
        width: 90px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 3px;
        color: #FFFFFF;
        background-color: #000000;
        .triangle{
          position: absolute;
          left: 45px;
          top: -10px;
          border: 4px solid transparent;
          border-bottom-width: 8px;
          border-bottom-color: #000000;
        }
      }
      .power-list-tree-dialog{
        .el-dialog{
          min-width: 538px;
        }
        .el-dialog__body{
          padding: 18px;
          padding-bottom: 0;
          .power-list-tree-dialog-content{
            width: 100%;
            display: flex;
            height: 460px;
            .group,.member{
              height: 100%;
              overflow-y: scroll;
            }
            .group{
              flex: 1 1 35%;
              h5{
                font-size: 12px;
                color: #999898;
                font-weight: 400;
                margin-bottom: 16px;
              }
              p{
                color: #2A2929;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &:not(:last-of-type){
                  margin-bottom: 18px;
                }
              }
            }
            .member{
              flex: 1 1 65%;
              .el-table.power-list-tree-dialog-content-table{
                &::before{
                  height: 0;
                }
                .el-table__header{
                  tr th{
                    border-bottom: none;
                    .cell{
                      color: #999898;
                    }
                  }
                }
                .el-table__body{
                  tr td{
                    border-bottom: none;
                    .cell{
                      color: #2A2929;
                    }
                  }
                }
              }
              .el-pagination{
                float: right;
                margin-left: 40px;
                span{
                  cursor: pointer;
                  color: #2A2929;
                  font-size: 12px;
                  font-weight: 400;
                  &:first-of-type{
                    margin-right: 26px;
                  }
                  &.disable-prev,&.disable-next{
                    color: #D7D8D9;
                  }
                  .fa{
                    color: #D7D8D9;
                    margin: 0 10px;
                  }
                  &:not(.disable-prev):not(.disable-next):hover{
                    .fa{
                      color: var(--primary, #4592E4);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/power-list-tree.vue